import { Skeleton, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import { toOptionalFixed } from '@app/helpers/format';
import { useTokenPriceValue } from '@app/hooks/token/useTokenPriceValue';

interface Props {
  tokenAddress: string | undefined;
  value: string;
  symbol: string | undefined;
}

export const TokensPrice: FC<Props> = ({ value, tokenAddress }) => {
  const { value: priceValue, isLoading } = useTokenPriceValue(
    value,
    tokenAddress
  );

  if (isLoading) {
    return (
      <Skeleton
        height="16px"
        width="64px"
        startColor="neutral.700"
        endColor="neutral.800"
        mb="2px"
      />
    );
  }

  return (
    <Text
      color="neutral.400"
      fontSize="12px"
      fontWeight="400"
      lineHeight="18px"
      letterSpacing="-0.18px"
    >
      ${priceValue !== undefined ? toOptionalFixed(+priceValue, 2) : priceValue}
    </Text>
  );
};
